module.exports = __webpack_public_path__ + "img/security.d64a51e1.png";